import { snackbar } from 'src/components/common/snackbar/Snackbar';
import { ILoginCredentials } from 'src/features/auth/domain/types';
import { login } from 'src/features/auth/store';
import { AppDispatch } from 'src/store';

export class AuthService {
	constructor(private dispatch: AppDispatch) {}

	async handleLogin(credentials: ILoginCredentials): Promise<boolean> {
		try {
			const response = await this.dispatch(login(credentials)).unwrap();
			return !!response.access && !!response.refresh;
		} catch (error: unknown) {
			const err = error as IErrorResponse;
			if (err?.description) {
				snackbar(err.description, 'error');
			} else if (error instanceof Error) {
				snackbar(error.message, 'error');
			} else {
				snackbar('Login failed. Please try again.', 'error');
			}
			return false;
		}
	}
}
